import { Mote } from './mote';

const shareProviders = {
    facebook: 'https://www.facebook.com/sharer/sharer.php',
    googleplus: 'https://plus.google.com/share',
    twitter: 'https://twitter.com/intent/tweet/',
    linkedin: 'https://www.linkedin.com/shareArticle',
    pinterest: 'https://www.pinterest.com/pin/create/button/'
}

export class Sharing {

    public mote: Mote;
    public url: string;

    public title: string;
    public message: string;
    public sharedBy: string;
    public createdOn: number;
    public createdBy: string;
    public moteKey: string;

    public seen: boolean = false;
    public key: string;

    constructor(
        mote: Mote = null,
        url: string = null
    ) {
        this.setSharing(mote, url);
    }

    public updateFromJson(json, key) {
        this.url = json.url || "";
        this.title = json.title || "";
        this.message = json.message || "";
        this.moteKey = json.moteKey || "";
        this.createdOn = json.createdOn || "";
        this.createdBy = json.createdBy || "";
        this.seen = json.seen || false;
        this.key = key;
    }

    public toJson(): any {
        // Map mote to DB object
        return {
            url: this.url,
            title: this.title,
            message: this.message,
            moteKey: this.moteKey,
            createdOn: this.createdOn,
            createdBy: this.createdBy
        }
    }

    public setSharing(mote: Mote = null, url: string = null): void {
        this.mote = mote || null;
        this.url = url || null
        if(mote) this.moteKey = mote.key;
        this.message = "You can find it here: " + this.url;
        if(mote) this.title = "I found a Mote: " + mote.title;
        this.createdOn = Date.now();
    }

    //https://ionicframework.com/docs/native/social-sharing/
    public forNative() {
        // let media = null;
        // if(this.mote.image) media = this.mote.image.url;
        // return this.message, this.title, media, this.url;
    }

    public forEmail(): string {
        return 'mailto:?subject=' + this.title + ' &body=' + this.message;
    }

    public forFacebook(): string {
        return shareProviders.facebook + '?u=' + this.url;
    }

    public forTwitter(): string {
        return shareProviders.twitter + '?url=' + this.url + '&hashtags=motes,' + this.mote.title
    }

    public forGooglePlus(): string {
        return shareProviders.googleplus + '?url=' + this.url;
    }

    public forLinkedIn() {
        return shareProviders.linkedin + '?url=' + this.url;
    }

    public forPinterest() {
        let media: string = '';
        //if(this.mote.mediaArray && this.mote.mediaArray[0]) media = this.mote.mediaArray.url
        return shareProviders.pinterest + '?url=' + this.url + '&media=' + media + '&description=' + this.title;
    }
}
